import { Pipe, PipeTransform } from '@angular/core';
import { Dayjs } from 'dayjs';
import { ISO8601Date } from '../app.types';
import { renderFancyDateTime } from '../utilities/formatting-helpers';

@Pipe({
  name: 'appDateTime'
})
export class AppDateTimePipe implements PipeTransform {
  transform(input?: Date | Dayjs | ISO8601Date): string {
    return input ? renderFancyDateTime(input) : '';
  }
}
